export default "__VITE_ASSET__DVtzZlyt__"